import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { ModelState } from "../../interfaces/modelState";
import { Card } from "../card/Card";
import TextInput from "../InputFields/TextInput";
import { V5, V25 } from "../InputFields/validator/validators";

interface Props {
  fields: Record<string, Field<string>>;
  modelState: ModelState | null;
  onUpdateIbanNumber: (iban: string) => void;
  setModelState: (updatedModelState: ModelState) => void;
  valueIban?: string;
  required: boolean;
  propertyNameOverride?: string;
}

export const IbanNumber = ({
  fields,
  modelState,
  onUpdateIbanNumber,
  setModelState,
  valueIban,
  required,
  propertyNameOverride,
}: Props) => {
  const propertyName = propertyNameOverride ?? "model.Iban";

  return (
    <Card>
      <h2>
        <Text field={fields.HeadingIban} />
      </h2>
      <TextInput
        fieldData={fields}
        onBlur={onUpdateIbanNumber}
        name="Iban"
        modelState={modelState}
        setModelState={setModelState}
        inputValue={valueIban}
        validators={[V5, V25]}
        propertyName={propertyName}
        fieldName="Iban"
        capitalize={true}
        required={required}
      />
    </Card>
  );
};
